import { render, staticRenderFns } from "./SuperDocDrawer.vue?vue&type=template&id=68797aac&scoped=true"
import script from "./SuperDocDrawer.vue?vue&type=script&lang=js"
export * from "./SuperDocDrawer.vue?vue&type=script&lang=js"
import style0 from "./SuperDocDrawer.vue?vue&type=style&index=0&id=68797aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68797aac",
  null
  
)

export default component.exports